<template>
  <div id="lom-list">
    <overlay-loading-progress :LoadingFlag="SubmitFlag" />
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ PageTitle }} - {{ YearName }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          @click.prevent="backPage"
          color="#EDBE38"
          elevation="30"
          shaped
          class="font-size-h6 fsize-3 mr-3 my-3 white--text"
        >
          <v-icon dark> mdi-arrow-left-circle </v-icon> &nbsp; Back
        </v-btn>
        <v-btn
          @click.prevent="refreshPageData"
          color="#0097D7"
          elevation="30"
          shaped
          class="font-size-h6 fsize-3 mr-3 my-3 white--text"
        >
          <v-icon dark> mdi-refresh </v-icon> &nbsp; Refresh
        </v-btn>
      </v-card-title>

      <v-card-subtitle class="text-h5">
        <h4>{{ PageDescription }}</h4>
      </v-card-subtitle>

      <v-card-text>
        <div class="d-flex justify-center mb-3" v-if="LoadingFlag">
          <b-spinner variant="primary" type="grow" label="Loading..." />
        </div>
        <h6>
          <v-btn text :href="FileName" target="_blank" class="text-none pa-0">
            click here
          </v-btn>
          to download the sample file
        </h6>

        <v-container>
          <v-row wrap>
            <v-col cols="12" sm="6" md="4">
              <v-form
                ref="form1"
                v-model="valid1"
                lazy-validation
                @submit.prevent="submitForm"
              >
                <label class="my-label">
                  <h6><span class="text-danger">* </span><b>Upload</b></h6>
                </label>

                <v-file-input
                  v-model="UploadedFile1"
                  accept=".xls,.xlsx"
                  placeholder="Upload excel file"
                  prepend-icon="mdi-file-excel"
                  truncate-length="25"
                  :clearable="false"
                  :rules="fileRules"
                >
                  <template v-slot:append>
                    <v-icon color="red" @click="UploadedFile1 = []">
                      fa-trash
                    </v-icon>
                  </template>
                </v-file-input>

                <v-btn
                  id="step12"
                  type="submit"
                  color="primary"
                  class="font-size-h6 fsize-3 mr-3 my-3 white--text"
                >
                  Submit
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" v-if="check != ''">
              <h6 v-html="check"></h6>
            </v-col>
            <v-col
              align="center"
              cols="12"
              sm="12"
              md="12"
              lg="12"
              v-if="output != ''"
            >
              <h3 v-html="output"></h3>
            </v-col>
          </v-row>
          <br />
          <br />
          <v-data-table
            style="font-size: 40px"
            v-if="rows.length > 0"
            v-model="selected"
            class="custom-data-table"
            item-class="custom-row-style"
            :headers="TableColumns1"
            :items="rows"
            :items-per-page="50"
            :search="search"
            :single-select="false"
            :show-select="false"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50],
            }"
          >
            <template v-slot:[`item.Description`]="{ item }">
              <div v-html="item.Description"></div>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import StudentScholarshipPreview from "@/view/pages/erp/student-scholarship/StudentScholarshipPreview.vue";
import Swal from "sweetalert2";

export default {
  components: { StudentScholarshipPreview },

  mixins: [common],
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SearchButtonFlag: false,
      SubmitFlag: false,
      SpeedDialFlag: false,
      search: "",

      FileName: "",

      DownloadFlag: 0,
      ExcelFileName: "",
      ExcelFields: "",
      BulkUploadPermissionFlag: "",
      recordToEdit: "",
      record: {},
      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      editPageDescription: "Assign LO President for JCI India",

      LomDataPageTitle: "",
      LomDataPreviewFlag: false,
      LomDataParams: {},

      rows: [],
      selected: [],
      TableColumns1: [],
      TableOptions1: {
        CreateButtonFlag: false,
      },

      selectedData: {},
      UploadedFile1: [],
      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      fileRules: [(v) => !!v || "File is required"],

      zone: {},
      lom: {},

      tableData1: {},
      check: "",
      output: "",
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  mounted() {
    /*
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Vuetify", route: "alerts" },
            { title: "Form Inputs & Control", route: "autocompletes" },
            { title: "Fileinptus" },
          ]);
          */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var server_url = companyConfig.apiURL;
        this.FileName = server_url + "assets/sample/member_update_sample.xlsx";

        this.pageData();
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "user_update",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    backPage() {
      this.$router.go(-1);
    },

    pageData() {
      console.log("pageData called");
      this.getJciYearCodeOptions();
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log({ validate1 });

      if (validate1) {
        this.check = "";
        this.output = "";
        this.TableOptions1 = {};
        this.TableColumns1 = [];
        this.rows = [];
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/users/bulk-update";

        let upload = new FormData();
        upload.append("UserInterface", 1);
        upload.append("UploadFile", this.UploadedFile1);

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log({ response });

            thisIns.SubmitFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            console.log({ flag }, { output });

            thisIns.check = response.data.check || "";
            thisIns.output = output;

            records = response.data.records;
            console.log({ records });

            thisIns.TableOptions1 = records.TableOptions;
            thisIns.TableColumns1 = records.TableHeader;
            thisIns.rows = records.TableData;
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "Kindly fill all required fields";
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* This is for documentation purposes and will not be needed in your application */

#lom-list {
  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .custom-data-table {
    font-size: 20px !important;
  }

  .custom-row-style {
    font-size: 30px !important;
  }

  .v-data-table-header th {
    font-size: 20px !important;
  }

  .v-data-table td {
    font-size: 16px !important;
  }
  .v-speed-dial--right {
    right: 5%;
  }
  #card-text {
    text-align: center;
    color: white;
  }
  #card-text h5 {
    font-size: 34px;
  }
  #card-text h2 {
    font-size: 34px;
    font-weight: 900;
  }
  #card-text h1 {
    font-size: 44px;
    font-weight: 900;
  }
}
</style>